import React, { useState } from "react";
import Modal from "react-modal";
import { useSelector, useDispatch } from "react-redux";
import { airportcity } from "../utils";
import { selectSearch, setSearchOption } from "amadeusredux/lib/searchSlice";
import MapOption from "./MapOption.js";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import germany from "../germany.json";
import Train from "../assets/train.png";
import Plane from "../assets/plane.png";
import { RiCloseFill } from "react-icons/ri";

export default function MapModal(props) {
  Modal.setAppElement("#root");

  const departureStations = useSelector(
    (state) => state.properties.departureStations
  );

  const dispatch = useDispatch();
  const { stations } = useSelector(selectSearch);
  const stationCodes = [...new Set(stations.map((item) => item.value))];
  console.log(stations);
  console.log(stationCodes);

  const { handleClose } = props;

  const handleSelectAll = (data) => {
    let tmpstations = [];
    if (stations.length > 0) {
      tmpstations = [...new Set(stations.map((item) => item.value))];
    }
    let tmpdata = [];
    if (data.length > 0) {
      tmpdata = [...new Set(data.map((item) => item.value))];
    }
    if (tmpdata.every((o) => tmpstations.includes(o))) {
      tmpstations = tmpstations.filter((o) => !tmpdata.includes(o));
    } else {
      tmpstations = [...tmpstations, ...tmpdata];
    }

    let uniqueairports = [...new Set(tmpstations.map((item) => item))];
    let val = [];
    for (let i = 0; i < uniqueairports.length; i++) {
      val.push({
        value: uniqueairports[i],
        label: airportcity(uniqueairports[i]),
      });
    }
    airportcity();
    dispatch(setSearchOption({ property: "stations", data: val }));
  };

  const handleSelect = (e, data) => {

    let tmpstations = [];
    if (stations.length > 0) {
      tmpstations = [...new Set(stations.map((item) => item.value))];
    }
    if (tmpstations.includes(data)) {
      tmpstations = tmpstations.filter((o) => !(o == data));
    } else {
      tmpstations = [...tmpstations, data];
    }

    let uniqueairports = [...new Set(tmpstations.map((item) => item))];
    let val = [];
    for (let i = 0; i < uniqueairports.length; i++) {
      val.push({
        value: uniqueairports[i],
        label: airportcity(uniqueairports[i]),
      });
    }
    airportcity();
    dispatch(setSearchOption({ property: "stations", data: val }));
  };

  const groupDepartureStations = () => {
    let tmp = [];
    if (Array.isArray(departureStations)) {
      tmp = [...departureStations];
    }
    if (Array.isArray(tmp)) {
      let tmpall = {
        label: (() => {
          return (
            <div className="mapmodal">
              {"Alle Flughäfen"}{" "}
              <a
                className="selectAll"
                onClick={() => handleSelectAll(tmpall.options)}
              >
                {"alle auswählen"}
              </a>
            </div>
          );
        })(),
        options: [],
      };
      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i].airports) {
          let tmpoption = {
            label: (() => {
              return (
                <div className="mapmodal1">
                  {tmp[i].label}{" "}
                  <a
                    className="selectAll"
                    onClick={() => handleSelectAll(tmp[i].options)}
                  >
                    {"alle auswählen"}
                  </a>
                </div>
              );
            })(),
            options: [],
          };
          for (let j = 0; j < tmp[i].airports.length; j++) {
            tmpoption.options.push({
              value: tmp[i].airports[j],
              label: airportcity(tmp[i].airports[j]),
            });
          }
          tmp[i] = tmpoption;
        } else {
          tmpall.options.push(tmp[i]);
        }
      }
      tmp.push(tmpall);
    }
    tmp = tmp.filter((o) => o.options);
    return tmp;
  };

  let groupedDepartureStations = groupDepartureStations();

  const koordinaten = [
    [13.501997992, 52.3666652],
    [8.785330192, 53.041833166],
    [7.138999444, 50.859496562],
    [13.76749693, 51.133999464],
    [7.607330904, 51.517664596],
    [6.7666636, 51.286998852],
    [10.954829514, 50.974496102],
    [9.506831306, 47.669497322],
    [8.0749997, 48.774330236],
    [10.239499042, 47.988829378],
    [7.684830594, 52.13499946],
    [8.5621518, 50.0379326],
    [8.337665316, 54.907996368],
    [9.684330596, 52.456498174],
    [9.987996048, 53.624830834],
    [7.258498966, 49.942329564],
    [9.3922222222, 51.4208333333],
    [10.718163794, 53.803163454],
    [12.235165726, 51.420998316],
    [11.68749725, 48.135999456],
    [6.138666112, 51.601497594],
    [11.073499706, 49.49249803],
    [8.616997532, 51.60916423],
    [6.788996844, 51.218832458],
    [6.958015, 50.943151],
    [6.97166278, 50.937829582],
    [13.369181, 52.52493],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [13.725663764, 51.03749985],
    [12.375998496, 51.340498638],
    [11.081942, 49.44623],
    [10.003833318, 53.55166446],
    [11.552997788, 48.137832782],
    [8.056999772, 52.270332252],
    [9.741046, 52.37655],
    [9.175665964, 48.783663532],
  ];

  const coordinates = [
    {
      value: "BER",
      label: "Flughafen Berlin-Brandenburg",
      lon: 13.501997992,
      lat: 52.3666652,
    },
    {
      value: "BRE",
      label: "Flughafen Bremen",
      lon: 8.785330192,
      lat: 53.041833166,
    },
    {
      value: "CGN",
      label: "Flughafen Köln-Bonn",
      lon: 7.138999444,
      lat: 50.859496562,
    },
    {
      value: "DRS",
      label: "Flughafen Dresden",
      lon: 13.76749693,
      lat: 51.133999464,
    },
    {
      value: "DTM",
      label: "Flughafen Dortmund",
      lon: 7.607330904,
      lat: 51.517664596,
    },
    {
      value: "DUS",
      label: "Flughafen Düsseldorf",
      lon: 6.7666636,
      lat: 51.286998852,
    },
    {
      value: "ERF",
      label: "Flughafen Erfurt-Weimar",
      lon: 10.954829514,
      lat: 50.974496102,
    },
    {
      value: "FDH",
      label: "Bodensee-Airport Friedrichshafen",
      lon: 9.506831306,
      lat: 47.669497322,
    },
    {
      value: "FKB",
      label: "Flughafen Karlsruge/Baden-Baden",
      lon: 8.0749997,
      lat: 48.774330236,
    },
    {
      value: "FMM",
      label: "Flughafen Memmingen",
      lon: 10.239499042,
      lat: 47.988829378,
    },
    {
      value: "FMO",
      label: "Flughafen Münster/Osnabrück",
      lon: 7.684830594,
      lat: 52.13499946,
    },
    {
      value: "FRA",
      label: "Flughafen Frankfurt Am Main",
      lon: 8.5621518,
      lat: 50.0379326,
    },
    {
      value: "GWT",
      label: "Flughafen Sylt",
      lon: 8.337665316,
      lat: 54.907996368,
    },
    {
      value: "HAJ",
      label: "Flughafen Hannover",
      lon: 9.684330596,
      lat: 52.456498174,
    },
    {
      value: "HAM",
      label: "Flughafen Hamburg",
      lon: 9.987996048,
      lat: 53.624830834,
    },
    {
      value: "HHN",
      label: "Flughafen Frankfurt-Hahn",
      lon: 7.258498966,
      lat: 49.942329564,
    },
    {
      value: "KSF",
      label: "Flughafen Kassel",
      lon: 9.3922222222,
      lat: 51.4208333333,
    },
    {
      value: "LBC",
      label: "Flughafen Lübeck",
      lon: 10.718163794,
      lat: 53.803163454,
    },
    {
      value: "LEJ",
      label: "Flughafen Leipzig/Halle",
      lon: 12.235165726,
      lat: 51.420998316,
    },
    {
      value: "MUC",
      label: "Flughafen München",
      lon: 11.68749725,
      lat: 48.135999456,
    },
    {
      value: "NRN",
      label: "Flughafen Niederrhein",
      lon: 6.138666112,
      lat: 51.601497594,
    },
    {
      value: "NUE",
      label: "Flughafen Nürnberg",
      lon: 11.073499706,
      lat: 49.49249803,
    },
    {
      value: "PAD",
      label: "Flughafen Paderborn-Lippstadt",
      lon: 8.616997532,
      lat: 51.60916423,
    },
    {
      value: "QDU",
      label: "Hauptbahnhof Düsseldorf",
      lon: 6.788996844,
      lat: 51.218832458,
    },
    {
      value: "QKL",
      label: "Hauptbahnhof Köln",
      lon: 6.958015,
      lat: 50.943151,
    },
    {
      value: "QKU",
      label: "Bahnhof Köln Deutz",
      lon: 6.97166278,
      lat: 50.937829582,
    },
    {
      value: "QPP",
      label: "Hauptbahnhof Berlin",
      lon: 13.369181,
      lat: 52.52493,
    },
    {
      value: "RLG",
      label: "RLG (Rostock-Laage)",
      lon: 12.273665572,
      lat: 53.917662996,
    },
    {
      value: "SCN",
      label: "SCN (Saarbrücken)",
      lon: 7.105666244,
      lat: 49.208665832,
    },
    {
      value: "STR",
      label: "STR (Stuttgart)",
      lon: 9.219832454,
      lat: 48.687330584,
    },
    {
      value: "TXL",
      label: "TXL (Berlin-Tegel)",
      lon: 13.285998856,
      lat: 52.55583111,
    },
    {
      value: "XIR",
      label: "Hauptbahnhof Dresden",
      lon: 13.725663764,
      lat: 51.03749985,
    },
    {
      value: "XIT",
      label: "Hauptbahnhof Leipzig",
      lon: 12.375998496,
      lat: 51.340498638,
    },
    {
      value: "ZAQ",
      label: "Hauptbahnhof Nürnberg",
      lon: 11.081942,
      lat: 49.44623,
    },
    {
      value: "ZMB",
      label: "Hauptbahnhof Hamburg",
      lon: 10.003833318,
      lat: 53.55166446,
    },
    {
      value: "ZMU",
      label: "Hauptbahnhof München",
      lon: 11.552997788,
      lat: 48.137832782,
    },
    {
      value: "ZPE",
      label: "Hauptbahnhof Osnabrück",
      lon: 8.056999772,
      lat: 52.270332252,
    },
    {
      value: "ZVR",
      label: "Hauptbahnhof Hannover",
      lon: 9.741046,
      lat: 52.37655,
    },
    {
      value: "ZWS",
      label: "Hauptbahnhof Stuttgart",
      lon: 9.175665964,
      lat: 48.783663532,
    },
  ];

  return (
    <>
      <div className="mapmodalclose" onClick={()=>handleClose()}>
      <RiCloseFill/>
      </div>
      <div className="mapmodalouter">
      <div className="mapmodalmain">
        <div className="headline">
          <div>Wählen Sie Ihren Start</div>
          <button
            className="mapok"
            onClick={() => handleClose()}
            style={{
              margin: 0,
              backgroundColor: "#c4cf7c",
              color: "#000000",
              borderRadius: "5px",
            }}
          >
            Übernehmen
          </button>
        </div>
        <div className="mapmodalcontent">
          <div className="mapdiv">
            <ComposableMap
              width={350}
              height={450}
              projectionConfig={{
                center: [10.5, 50.5],
                scale: 3000,
              }}
            >
              <Geographies geography={germany}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      fill="#c4cf7c"
                      stroke="#000000"
                      key={geo.rsmKey}
                      geography={geo}
                    />
                  ))
                }
              </Geographies>
              {coordinates.map((o, i) => {
                return (
                  <Marker coordinates={[o.lon, o.lat]}>
                    <circle
                      r={5}
                      fill={
                        stationCodes.includes(o.value) ? "#0000FF" : "#808080"
                      }
                    ></circle>
                  </Marker>
                );
              })}
            </ComposableMap>
          </div>
          <div className="mapmodalcontentoptions">

          {Array.isArray(groupedDepartureStations) &&
            groupedDepartureStations.length > 0 &&
            groupedDepartureStations.map((o, i) => {
              return (
                <div
                  className={
                    o.options.length > 11
                      ? "mapoptionsdivlong"
                      : "mapoptionsdiv"
                  }
                  key={i}
                >
                  <div className="mapoptionheader">{o.label}</div>
                  <div className="mapoptionbody">
                    {Array.isArray(o.options) &&
                      o.options.length > 0 &&
                      o.options.map((obj, j) => {
                        return (
                          <MapOption
                            cname={
                              o.options.length > 11
                                ? "mapoptionlong"
                                : "mapoption"
                            }
                            myvalue={obj.value}
                            label={obj.label}
                            checked={stationCodes.includes(obj.value)}
                            key={j}
                            handleClick={(e) => handleSelect(e, obj.value)}
                          />
                        );
                      })}
                  </div>
                </div>
              );
            })}
            </div>
        </div>
      </div>
      </div>
    </>
  );
}
